import ModalActionsPricePromo from './ModalActionsPricePromo'
export default ModalActionsPricePromo
